import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=727e0d6d&scoped=true"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=727e0d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e0d6d",
  null
  
)

export default component.exports